<template>
  <div v-if="open" class="headerPopup">
    <div class="wrapper">
      <div class="flex justify-center">
        <div class="text-wrap">
          <p class="fs-14"> {{ text }}
          </p>
        </div>
        <button class="closeBtn" type="button" @click="close">x</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderPopup",
  methods: {
    close() {
      this.$store.commit('toggleHeaderPopup', false)
    }
  },
  computed: {
    open() {
      return this.$store.state.main.headerPopupOpen
    },
    text() {
      return this.$store.state.main.headerErrorText
    },
  },
  watch: {
    open(value) {
      if (value) {
        document.getElementsByTagName('body')[0].classList.add('vh100')
      } else {
        document.getElementsByTagName('body')[0].classList.remove('vh100')
      }
    },
  }
}
</script>
